<template lang="pug">
  .clients(v-if="isConsultant")
    .clients__layout
      h2.clients__title {{ 'base.clients' | translate }}
      .clients__toolbar
        template(v-if="!isMobile")
          v-btn(
            v-if="isAdmin"
            medium
            @click="modals.showCreateClient = true")
            v-icon(
              position-left
              font-size="1"
              icon="plus").mr-1
            span {{ 'activities.add_client' | translate }}
          v-btn(
            v-if="false"
            medium
            @click="toActivities")
              span  Активність
        template(v-else)
          v-btn(
            v-if="isAdmin"
            fab
            @click="modals.showCreateClient = true")
            v-icon(
              font-size="1.2"
              icon="plus")
      v-dialog(
        max-width="730"
        v-model="modals.showCreateClient")
        create-client-modal(
          @update="onUpdate"
          @close="modals.showCreateClient = false")

    clients-list(ref="ClientsListData")
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import CreateClientModal from './modals/CreateClientModal'
import ClientsList from './ClientsList'

export default {
  name: 'ManagerMain',

  mixins: [adaptationMixin],

  components: {
    ClientsList,
    CreateClientModal
  },

  data: () => ({
    modals: {
      showCreateClient: false
    }
  }),

  methods: {
    onUpdate () {
      this.$refs.ClientsListData.loadItems()
    },
    toActivities () {
      this.$router.push({ path: '/app/activities' })
    }
  }
}
</script>

<style lang="scss">
@import '@/sass/abstracts/_variables.scss';
@import '@/sass/abstracts/_mixins.scss';

.clients {
  &__layout {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2.5rem;
  }

  &__title {
    font-size: 3rem;
    font-weight: 700;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -1rem;
  }

  &__item {
    width: 25%;
    padding: 0 1rem;
    margin-bottom: 2rem;

    @include tablet {
      width: 33.3%;
    }

    @include mobile {
      width: 100%;

      &:not(:last-child) {
        margin-bottom: 1.5rem;
      }
    }
  }

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem .5rem 1.5rem 0;
  }

  &__info {
    padding-right: .5rem;
    padding-left: 2.5rem;
    border-left: .4rem solid $color-primary;

    &--deleted {
      border-left: .4rem solid $color-orange;
    }
  }
}
.clients__toolbar {
  display: flex;
  gap: 16px;
  flex-direction: row-reverse;
}
</style>
